export const baseTooltipStyles = {
  backgroundColor: '#FFF',
  titleColor: '#000',
  bodyColor: '#000',
  borderWidth: 2,
  borderColor: '#DBDBDB',
};
